import React, { useEffect, useState } from "react";

import { Navigate, Outlet } from "react-router-dom";

import api from "../../utils/api";
import {
  getEffectiveDashboardRole,
  getImpersonationState,
  getUserIdFromAccessToken,
  isAdminRole,
  isClientRole,
  persistAuthUser,
} from "../../lib/authSession";



/**

 * Restricts dashboard routes to the correct role (user vs admin).

 */

const RoleGuard = ({ requiredRole }) => {

  const [sessionVersion, setSessionVersion] = useState(0);



  useEffect(() => {

    const bump = () => setSessionVersion((value) => value + 1);

    window.addEventListener("repman:session-changed", bump);

    window.addEventListener("storage", bump);

    return () => {

      window.removeEventListener("repman:session-changed", bump);

      window.removeEventListener("storage", bump);

    };

  }, []);



  useEffect(() => {

    if (requiredRole !== "client") return undefined;

    let cancelled = false;

    (async () => {

      try {

        const profile = await api.get("/api/users/profile/", { auth: true });

        if (cancelled) return;

        const tokenUserId = getUserIdFromAccessToken(

          typeof window !== "undefined"

            ? window.localStorage.getItem("repman_access_token")

            : ""

        );

        if (

          tokenUserId != null &&

          Number(tokenUserId) !== Number(profile.id)

        ) {

          return;

        }

        const impersonating = Boolean(getImpersonationState()?.active);

        if (profile.role === "admin" && !impersonating) {

          persistAuthUser(profile, { allowUserSwitch: true });

          setSessionVersion((value) => value + 1);

          return;

        }

        persistAuthUser(profile);

      } catch {

        /* profile sync is best-effort */

      }

    })();

    return () => {

      cancelled = true;

    };

  }, [requiredRole]);



  const role = getEffectiveDashboardRole();

  const hasToken =

    typeof window !== "undefined" &&

    Boolean(window.localStorage.getItem("repman_access_token"));



  // sessionVersion keeps the guard reactive when localStorage session changes.

  void sessionVersion;



  if (!hasToken || !role) {

    return <Navigate to="/anmelden" replace />;

  }



  if (requiredRole === "admin" && !isAdminRole(role)) {

    return <Navigate to="/dashboard/client" replace />;

  }



  if (requiredRole === "client" && !isClientRole(role)) {

    return <Navigate to="/dashboard/admin" replace />;

  }



  return <Outlet />;

};



export default RoleGuard;


